import { FC } from "react"

interface TopReferrer {
  participant_id: string
  username: string
  referral_code: string
  referral_count: number
  referral_points_earned: number
}

interface TopReferrersTableProps {
  referrers: TopReferrer[]
}

export const TopReferrersTable: FC<TopReferrersTableProps> = ({ referrers }) => {
  if (referrers.length === 0) return null

  return (
    <div className="px-6 pb-4">
      <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">Top Referrers</h4>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 dark:bg-[rgba(139,92,246,0.05)]">
            <tr>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Player</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Code</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Referrals</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Points Earned</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[rgba(0,0,0,0.05)] dark:divide-[rgba(255,255,255,0.1)]">
            {referrers.map((referrer) => (
              <tr key={referrer.participant_id} className="hover:bg-gray-50 dark:hover:bg-[rgba(139,92,246,0.05)]">
                <td className="px-4 py-2 text-sm font-medium text-gray-900 dark:text-white">{referrer.username}</td>
                <td className="px-4 py-2 text-sm text-gray-500 dark:text-gray-400 font-mono">{referrer.referral_code}</td>
                <td className="px-4 py-2 text-sm text-gray-900 dark:text-white">{referrer.referral_count}</td>
                <td className="px-4 py-2 text-sm font-medium text-green-600 dark:text-green-400">
                  {referrer.referral_points_earned.toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
